export enum ClassificationStatus {
  Draft = 4001,
  Registered = 4002,
  Expiring = 4003,
  Expired = 4004
}
